module.exports = __webpack_public_path__ + "static/img/9.0c1be4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/9.png
// module id = G6DZ
// module chunks = 0